module.exports = __webpack_public_path__ + "img/more-scenes-bg.40e22567.png";